module.exports = __webpack_public_path__ + "img/map.8b7c1687.png";